import React, { Fragment } from "react";
import SwipeableBottomSheet from "react-swipeable-bottom-sheet";
import { Header } from "semantic-ui-react";
import FormMessage from "./FormMessage";
/**
 * @author
 * @function Bottomslider
 **/

const Bottomslider = ({ children, onTextSend }) => {
  return (
    <Fragment>
      <div style={{ overflow: "hidden" }}>
        <SwipeableBottomSheet
          overflowHeight={70}
          style={{ width: window.innerWidth <= 800 ? "" : "400px" }}
          onChange={data => console.log(data)}
        >
          <Header
            as="h5"
            size="large"
            textAlign="center"
            style={{ padding: "22px", background: "#FBC91B" }}
          >
            This goes up :D
            {/* <LogoFooter /> */}
            {/* <a href="Ahmer Aftab Patel.pdf">Resume Download</a> */}
            {/* <Icon style ={{color : "white",textDecoration : "none"}} name="arrow down"/> */}
          </Header>
          <div
            style={{ height: "340px", overflowY: "auto", overflowX: "hidden" }}
          >
            {children}
          </div>
          <div style={{ bottom: 0, left: 0, overflow: "hidden" }}>
            <FormMessage onTextSend={onTextSend} />
          </div>
        </SwipeableBottomSheet>
      </div>
    </Fragment>
  );
};

export default Bottomslider;
